import useStorifyConfig from '@hooks/useStorifyConfig';
import { Skeleton } from '@design-system/Skeleton';

interface StorifyMeProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLElement>,
    HTMLElement
  > {
  account: string;
  widget: string;
  story?: string;
  env: 'eu';
  segments?: string[];
  playbackOptions?: 'restartStoriesWhenOpen' | 'alwaysResumeStoryWhereStopped'; // default: 'alwaysResumeStoryWhereStopped'
  logLevel?: 'all' | 'info' | 'warning' | 'error' | 'none'; // default: 'none'
  init?: 'auto' | 'manual';
  reorderStories?: 'onClose' | undefined;
}

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'storifyme-collection': StorifyMeProps;
    }
  }
}

export const HomeStorifyComponent = () => {
  const { tags, isStoriesLoading, isStorifyEnabled, storifyWidgetId } = useStorifyConfig(false);

  if (isStoriesLoading) {
    return (
      <div className="h-28 p-5 mb-6">
        <div className="flex flex-row gap-4">
          {Array.from({ length: 5 }).map((_, index) => (
            <div>
              <Skeleton
                key={`skeleton-${index}`}
                className="h-20 w-20 rounded-2xl flex bg-gray-600"
              />
              <Skeleton className="h-9 w-20 mb-4 bg-gray-600 rounded-lg mt-2" />
            </div>
          ))}
        </div>
      </div>
    )
  }

  if (!isStorifyEnabled || tags.length === 0) {
    return null;
  }

  return (
    <div className='flex justify-start min-h-36 !-ml-5 pt-6'>
      <storifyme-collection
        className='ml-6'
        account="viome-4593429"
        widget={storifyWidgetId}
        env="eu"
        segments={tags}
      />
    </div>
  )
}